import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LogService } from '@prekog/common-ui';

import { GetPartnerStatisticRequest } from '../../statistics/partnerstatistic/getpartnerstatistic.request';
import { GetPartnerStatisticResponse } from '../../statistics/partnerstatistic/getpartnerstatistic.response';
import { LoadStatisticsUseCase } from '../../shared/use-cases/load-statistics.usecase';
import { STORE_BACKEND_URL } from 'src/app/app.config';

@Injectable({
    providedIn: 'root'
})
export class LoadPartnerStatisticUseCase extends LoadStatisticsUseCase<GetPartnerStatisticRequest, GetPartnerStatisticResponse> {
    private _storeBaseUrl = inject<string>(STORE_BACKEND_URL);

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override getBackendUrl(): string {
        return this._storeBaseUrl;
    }

    protected override getApiUrl(): string {
        return '/admin/getPartnerStatistics';
    }
}
